<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <div class="flex-0 flex flex-row items-center justify-between w-full">

        <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="backToBriefs()" type="button" class="fab-button-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">{{ focussedBrief() ? focussedBrief()!.title : 'Loading...'
                        }}
                    </h3>
                    <span
                        class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset"
                        [class]="getBadgeColour()">{{
                        getPostType()
                        }}</span>
                </div>
                <p class="mt-0 text-xs text-secondary">Overall Brief Results</p>
            </div>
        </div>

        <div class="flex-1 flex flex-row items-center justify-center max-w-2/3 gap-x-2">

        </div>
    </div>
</div>